import { LitElement, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";
import "../lucide-icons/ellipsis.ts";

import { styles } from "./live-badge.css";

export type LiveBadgeStatus = "live" | "preview" | "paused";

@customElement("live-badge")
export class LiveBadge extends LitElement {
  static override styles = [styles];

  @property({ type: String })
  status: LiveBadgeStatus = "preview";

  @property({ type: String })
  label?: string;

  @property({ type: Boolean })
  bars?: boolean = false;

  override render() {
    const badgeClasses = {
      "live-badge": true,
      [this.status]: true,
    };

    const defaultLabels: Record<LiveBadgeStatus, string> = {
      live: "Live",
      preview: "Preview",
      paused: "Paused",
    };

    const displayLabel = this.label ?? defaultLabels[this.status];

    return html`
      <div class=${classMap(badgeClasses)}>
        ${this.bars
          ? html` <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="dots"
            >
              <path id="l1" d="M6,16 L6,18" />
              <path id="l2" d="M12,16 L12,18" />
              <path id="l3" d="M18,16 L18,18" />
            </svg>`
          : html`<div class="live-indicator"></div>`}
        <span>${displayLabel}</span>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "live-badge": LiveBadge;
  }
}
